import { Plugin } from 'vue';
import { install } from './plugin';
export { notify } from './notify';

export default {
  install,
} as Plugin;
